<div class="customer-estimate">
  <div class="content">

    <div class="ui-g-12 mt-2 justify-content-end p-zero">
      <div class="btn-group w-100 justify-content-end">
        <div class="ui-g-4">
          <button id="estimate-btn-estimate" class="btn btn-block btn-side-list float-right" (click)="openEstimer()">
            <i class="fal fa-clipboard black mr-1"></i>
            <i class="fal fa-plus black mr-1 d-none"></i>
            <span>Estimate</span>
          </button>
        </div>
        <div class="ui-g-4">
          <button id="estimate-btn-appointment" class="btn btn-block btn-side-list"
            (click)="openScheduleAppointmentModal()">
            <i class="fal fa-calendar-plus black mr-1"></i>
            <i class="fal fa-plus black mr-1 d-none"></i>
            <span>Appointment</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Start Active Estimates -->
    <div class="upcoming-estimate-section" *ngIf="activeEstimates.length > 0">
      <div class="ui-g-12">
        <div class="estimates-heading font-600">Active</div>
      </div>

      <!-- Estimate List Start -->
      <a *ngFor="let estimate of activeEstimates; let i=index;"
        class="ui-g-12 p-1 estimate-card flex-start-center mb-1 font-colors">
        <div class="ui-g-8 flex-start-center p-0 height-full">
          <div id="link-open-estimate-code{{i}}" class="flex-center-center estimate-code pointer p-1 pr-2" (click)="openEstimate(estimate)">
            <span class="font-16">{{estimate?.code}}</span>

            <div *ngIf="isMultiLocationEnabled && estimate?.shopId" class="location-pill mt-1">
              <span class="location-bg" [ngStyle]="{ backgroundColor: shopsMap[estimate?.shopId]?.shopColor }"></span>
              <p class="location-name" [ngStyle]="{ color: shopsMap[estimate?.shopId]?.shopColor }">
                <i class="fal fa-store-alt"></i>
                {{ shopsMap[estimate?.shopId]?.shopName }}
              </p>
            </div>
          </div>

          <div class="flex-column flex-center-start width-100p">
            <div class="width-90p flex-between-center">
              <p id="link-open-estimate-name{{i}}"
                class="font-16 font-600 estimate-name font-color pointer m-0 text-truncate open-link-container">

                <app-open-tab-link 
                    link="/estimate/{{estimate._id}}"
                    [tabId]="estimate._id"
                    [title]="estimate?.title || defaultTitle">
                    </app-open-tab-link>
              </p>

              <span class="btn btn-outline-secondary ml-1 capitalize" *ngIf="estimate?.orderStatus !== 'invoice'">
                {{estimate?.orderStatus}}
              </span>

              <span class="btn btn-outline-secondary ml-1 capitalize" *ngIf="estimate?.orderStatus === 'invoice'">
                {{estimate?.orderStatus}} # {{(estimate.orderStatus === 'invoice' && estimate.invCode)?
                estimate.invCode: estimate.code}}
              </span>
            </div>

            <div class="width-100p">
              <span class="font-11 estimate-details">
                <i class="fal fa-calendar"></i>&nbsp;
                {{estimate?.backdatedCreationDate ? this.helperService.convertTimezoneForRender(estimate?.backdatedCreationDate,fm.mmmdyyhhmmaa)?.date : this.helperService.convertTimezoneForRender(estimate?.createdAt,fm.mmmdyyhhmmaa)?.date}}
              </span>
            </div>

            <div class="width-100p">
              <span class="font-11 estimate-details">
                <i class="fal fa-car"></i>&nbsp;
                {{estimate?.vehicle?.name || defaultTitle}}
              </span>
            </div>
          </div>
        </div>

        <div class="ui-g-4 p-0 flex-column flex-center-end estimate-price height-full">
          <div id="text-estimate-price{{i}}" class="pr-1 mb-1">
            {{estimate?.total?.grand | currency: usd}}
          </div>

          <!-- <div class="pr-1">
            <span id="text-estimate-status{{i}}" class="estimate-status font-white"
              [ngClass]="{'approved' : estimate?.authorized, 'unapproved' : !estimate?.authorized}">
              {{estimate?.authorized ? 'Approved' : 'Unapproved'}}
            </span>
          </div> -->

          <div class="pr-1">
            <span id="text-estimate-status{{i}}" class="estimate-status font-white text-capitalize"
              [ngClass]="{'approved' : estimate?.authorizationStatus === 'approved', 'unapproved' : (estimate?.authorizationStatus === 'unapproved' || !estimate?.authorizationStatus),
              'partially-approved' : estimate?.authorizationStatus === 'partially'}">
              {{estimate?.authorizationStatus === 'partially' ? 'Partially Approved' : estimate?.authorizationStatus === 'approved' ? estimate?.authorizationStatus : estimate?.authorizationStatus ? 'unapproved' : estimate?.authorized}}
            </span>
          </div>
        </div>
      </a>
      <!-- Estimate List End -->
    </div>
    <!-- End Active Estimates -->

    <!-- Start Archived Estimates -->
    <div class="past-estimate-section" *ngIf="archivedEstimates?.length">
      <div class="ui-g-12 mt-2">
        <div class="estimates-heading font-600">Archived</div>
      </div>

      <!-- Estimate List Start -->
      <div class="ui-g-12 p-1 estimate-card flex-start-center mb-1"
        *ngFor="let estimate of archivedEstimates; let i = index;">
        <div class="ui-g-8 flex-start-center p-0 height-full">
          <div id="link-open-archived-estimate-code{{i}}" class="flex-center-center estimate-code pointer p-1"
            (click)="openEstimate(estimate)">
            <span class="font-16">{{estimate?.code}}</span>
          </div>

          <div class="flex-column flex-center-start width-100p">
            <div class="width-90p flex-between-center">
              <p id="link-open-archived-estimate-name{{i}}"
                class="font-16 font-600 estimate-name font-color pointer m-0 text-truncate"
                (click)="openEstimate(estimate)">
                {{estimate?.title || defaultTitle}}
              </p>

              <span class="btn btn-outline-secondary ml-1 capitalize" *ngIf="estimate?.orderStatus !== 'invoice' ">
                {{estimate?.orderStatus}}
              </span>

              <span class="btn btn-outline-secondary ml-1 capitalize" *ngIf="estimate?.orderStatus === 'invoice' ">
                {{estimate?.orderStatus}} # {{(estimate.orderStatus === 'invoice' && estimate.invCode)?
                estimate.invCode: estimate.code}}
              </span>
            </div>

            <div class="width-100p">
              <span class="font-11 estimate-details">
                <i class="fal fa-calendar"></i>&nbsp;
                {{estimate?.createdAt | date : 'MMM d, yyyy h:mm a'}}
              </span>
            </div>

            <div class="width-100p">
              <span class="font-11 estimate-details">
                <i class="fal fa-car"></i>&nbsp;
                {{estimate?.vehicle?.name || defaultTitle}}
              </span>
            </div>
          </div>
        </div>

        <div class="ui-g-4 p-0 flex-column flex-center-end estimate-price height-full">
          <div id="text-archived-estimate-price{{i}}" class="pr-1 mb-1">
            {{estimate?.total?.grand | currency: usd}}
          </div>

          <div class="pr-1">
            <span id="text-archived-estimate-status{{i}}" class="estimate-status"
              [ngClass]="{'approved' : estimate?.authorized, 'unapproved' : !estimate?.authorized}">
              {{estimate?.authorized ? 'Approved' : 'Unapproved'}}
            </span>
          </div>
        </div>
      </div>
      <!-- Estimate List End -->
    </div>
    <!-- End Archived Estimate -->

    <div *ngIf="!isProcessing && !activeEstimates.length && !archivedEstimates.length" class="ui-g-12 text-center mt-5">
      <img src="../../../../assets/img/estimate-list-empty.png" class="width-45" alt="">
      <p class="font-13">There is no estimate yet</p>
    </div>
  </div>
</div>
